import React, { useRef } from "react";
import useIsVisible from "../hooks/useIsVisible";
import ToolTip from "./tooltip";

const FloatingButtons = ({
  failedText,
  successText,
  successDisabled,
  handleFailed = () => {},
  handleSuccess = () => {},
  classNames,
  label,
  submitForm = false,
  showTooltipOnDisabled = false,
  tooltipMessage = "",
}) => {
  const ref = useRef();

  const isVisible = useIsVisible(ref);

  const primaryButton = (
    <button
      data-button-type="primary"
      onClick={handleSuccess}
      disabled={successDisabled}
      type={submitForm ? "submit" : "button"}
      form={submitForm || undefined}
    >
      {successText}
    </button>
  );

  return (
    <>
      {/* Footer buttons */}
      <div
        ref={ref}
        className={
          classNames ? `${classNames} action-buttons` : "action-buttons"
        }
      >
        <button
          data-button-type="secondary"
          data-action="cancel"
          onClick={(e) => {
            e.preventDefault();
            handleFailed();
          }}
        >
          {failedText}
        </button>
        {showTooltipOnDisabled && successDisabled ? (
          <ToolTip
            id="floating-save-tooltip"
            className="floating-save-tooltip"
            body={tooltipMessage}
            multiline
            place="bottom"
          >
            {primaryButton}
          </ToolTip>
        ) : (
          primaryButton
        )}
      </div>
      {/* Floating buttons */}
      {!successDisabled && (
        <div className={isVisible ? "no floating-globe" : "floating-globe"}>
          <p className="p4">{label}</p>
          <div className="action-buttons">
            <button
              data-button-type="secondary"
              data-action="cancel"
              onClick={(e) => {
                e.preventDefault();
                handleFailed();
              }}
            >
              {failedText}
            </button>
            {/* sucess button */}
            {primaryButton}
          </div>
        </div>
      )}
    </>
  );
};

export default FloatingButtons;
